import { colors } from "../../theme/colors"

export const ModalContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(5px)",
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
}

export const ModalWidthContainer = {
  padding: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  maxWidth: "440px",
  outline: "none",
}

export const BoxContainer = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
  background: "white",
  borderRadius: "20px",
  padding: "30px 20px 35px 20px",
  boxShadow: `0 10px 16px ${colors.shadowGrey}`,
  outline: 0,
}
